import { render, staticRenderFns } from "./Histone.vue?vue&type=template&id=6507cf17"
import script from "./Histone.vue?vue&type=script&lang=js"
export * from "./Histone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports